/**
 * Retail Box's own theme variables and where each falls back to: the same list as `retail_box` in
 * api-contract's `OPENER_KIND_TOKENS` (a test keeps them in step). The box follows the host's
 * accent and its stripe the accent's foreground, so a store's brand colors print on the box by
 * default; the tissue paper and the spotlight keep their studio whites until a style sets them.
 */
import type { OpenerTokenFallback } from "../../theme/theme";

export const RETAIL_BOX_TOKENS = {
  box: { role: "accent" },
  stripe: { role: "accentForeground" },
  tissue: { color: "#f3efe6" },
  spotlight: { color: "#fff4e0" },
} as const satisfies Record<string, OpenerTokenFallback>;
